import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { PERSISTED_THEME_FIELDS, saveThemeSettings } from 'utils/themeStorage';
import { onSystemThemeChange } from './slices/themeSlice';

// Guarda en localStorage los campos del tema que cambió el usuario
const themePersistMiddleware = (storeApi) => (next) => (action) => {
  const prevTheme = storeApi.getState().theme;
  const result = next(action);
  const { theme } = storeApi.getState();
  if (theme === prevTheme || action.type === onSystemThemeChange.type) {
    return result;
  }
  const changes = PERSISTED_THEME_FIELDS.reduce((acc, field) => {
    if (theme[field] !== prevTheme[field]) acc[field] = theme[field];
    return acc;
  }, {});
  if (Object.keys(changes).length) saveThemeSettings(changes);
  return result;
};

const middlewares = [themePersistMiddleware];

const store = configureStore({
  reducer: rootReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === 'development',
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(rootReducer(store.asyncReducers));
  return store;
};

export default store;
